import TypeToReducer from 'type-to-reducer';
import set from 'lodash/set';

import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';
import {
  RESET_CATALOG_FORM,
  GET_CATALOG_BY_ID,
  GET_CATALOG_FORM_CONFIG,
  MODIFY_EDITING_CATALOG,
  ADD_ELEMENT_EDITING_CATALOG,
  REMOVE_ELEMENT_EDITING_CATALOG,
} from 'catalogs/constants';

export const initialState = {
  isFetchingConfig: false,
  isFetching: false,
  isSaving: false,
  editing: { elements: [] },
};

export const resetForm = (state) => ({ ...initialState });

export const getByIdPending = (state) => ({ ...state, isFetching: true });

export const getByIdRejected = (state) => ({ ...state, isFetching: false });

export const getByIdFulfilled = (state, { payload }) => ({
  ...state,
  isFetching: false,
  editing: { ...payload.catalog },
});

export const getConfigPending = (state) => ({ ...state, isFetchingConfig: true });
export const getConfigRejected = (state) => ({ ...state, isFetchingConfig: false });
export const getConfigFulfilled = (state) => ({ ...state, isFetchingConfig: false });

export const modifyCatalog = (state, { payload }) => ({
  ...state,
  editing: {
    ...Object.keys(payload).reduce(
      (re, k) => {
        set(re, k, payload[k]);
        return re;
      },
      { ...state.editing }
    ),
  },
});

export const addElement = (state) => ({
  ...state,
  editing: {
    ...state.editing,
    elements: [
      ...state.editing.elements,
      { editable: true, active: true, deleted: false, key: '', value: '' },
    ],
  },
});

export const removeElement = (state, { payload }) => ({
  ...state,
  editing: {
    ...state.editing,
    elements: [
      ...state.editing.elements
        .map((e, i) => (i === payload ? { ...e, deleted: true } : e))
        .filter((e) => e.id || !e.deleted),
    ],
  },
});

const reducers = {
  [RESET_CATALOG_FORM]: resetForm,
  [GET_CATALOG_BY_ID]: {
    [PENDING]: getByIdPending,
    [REJECTED]: getByIdRejected,
    [FULFILLED]: getByIdFulfilled,
  },
  [GET_CATALOG_FORM_CONFIG]: {
    [PENDING]: getConfigPending,
    [REJECTED]: getConfigRejected,
    [FULFILLED]: getConfigFulfilled,
  },
  [MODIFY_EDITING_CATALOG]: modifyCatalog,
  [ADD_ELEMENT_EDITING_CATALOG]: addElement,
  [REMOVE_ELEMENT_EDITING_CATALOG]: removeElement,
};

export default TypeToReducer(reducers, initialState);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/reducers/catalogs_form_reducers.js